(function () {
  function clampRating(value) {
    const rating = Number(value);
    if (!Number.isFinite(rating)) return 0;
    return Math.max(0, Math.min(5, Math.floor(rating)));
  }

  function starText(value) {
    const rating = clampRating(value);
    return '\u2605'.repeat(rating) + '\u2606'.repeat(5 - rating);
  }

  function initLightbox(widget) {
    const dialog = widget.querySelector('.reviews-lightbox');
    if (!dialog) return;

    const image = dialog.querySelector('.reviews-lightbox__image');
    const name = dialog.querySelector('.reviews-lightbox__name');
    const body = dialog.querySelector('.reviews-lightbox__body');
    const stars = dialog.querySelector('.reviews-lightbox__stars');
    const close = dialog.querySelector('.reviews-lightbox__close');
    const nativeDialog = typeof dialog.showModal === 'function';
    let trigger = null;

    if (!image || !name || !body || !stars || !close) return;
    if (!nativeDialog) dialog.classList.add(dialog.dataset.fallbackClass || 'reviews-lightbox--fallback');

    function handleEscape(event) {
      if (event.key === 'Escape') closeLightbox();
    }

    function openLightbox() {
      if (nativeDialog) {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', handleEscape);
      }
    }

    function closeLightbox() {
      if (nativeDialog) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', handleEscape);
      }

      if (trigger) trigger.focus();
    }

    widget.querySelectorAll('.reviews-media-carousel__thumb').forEach(function (button) {
      button.addEventListener('click', function () {
        const data = button.dataset;

        trigger = button;
        image.src = data.src;
        image.alt = data.name || '';
        name.textContent = data.name || '';
        body.textContent = data.body || '';
        stars.textContent = starText(data.rating);
        openLightbox();
      });
    });

    close.addEventListener('click', closeLightbox);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeLightbox();
    });

    if (nativeDialog) {
      dialog.addEventListener('close', function () {
        if (trigger) trigger.focus();
      });
    }
  }

  function initCarousel(widget) {
    const track = widget.querySelector('.reviews-media-carousel__track');
    const prev = widget.querySelector('.reviews-media-carousel__prev');
    const next = widget.querySelector('.reviews-media-carousel__next');

    if (!track || !prev || !next) return;

    function updateArrows() {
      prev.hidden = track.scrollLeft < 1;
      next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -240, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: 240, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows);
    updateArrows();
  }

  function lineHeightPx(element) {
    const styles = window.getComputedStyle(element);
    const lineHeight = parseFloat(styles.lineHeight);

    if (Number.isFinite(lineHeight)) return lineHeight;

    const fontSize = parseFloat(styles.fontSize);
    return Number.isFinite(fontSize) ? fontSize * 1.5 : 24;
  }

  function initSummaryToggle(widget) {
    const summary = widget.querySelector('[data-reviews-summary]');
    const body = summary && summary.querySelector('[data-reviews-summary-body]');
    const toggle = summary && summary.querySelector('[data-reviews-summary-toggle]');

    if (!summary || !body || !toggle) return;

    const mediaQuery = window.matchMedia('(max-width: 699px)');
    const collapsedLabel = toggle.dataset.labelCollapsed || toggle.textContent.trim();
    const expandedLabel = toggle.dataset.labelExpanded || collapsedLabel;
    let resizeTimer = null;

    function setExpanded(expanded) {
      summary.classList.toggle('reviews-summary--expanded', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? expandedLabel : collapsedLabel;
    }

    function reset() {
      summary.classList.remove('reviews-summary--is-collapsible');
      summary.classList.remove('reviews-summary--expanded');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = collapsedLabel;
    }

    function refresh() {
      reset();

      if (!mediaQuery.matches) return;

      const maxCollapsedHeight = lineHeightPx(body) * 3;
      const hasOverflow = body.scrollHeight > maxCollapsedHeight + 1;

      if (!hasOverflow) return;

      summary.classList.add('reviews-summary--is-collapsible');
      toggle.hidden = false;
    }

    function scheduleRefresh() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    }

    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    window.addEventListener('resize', scheduleRefresh);

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', refresh);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(refresh);
    }

    refresh();
  }

  function initReviewsWidget(widget) {
    if (widget.dataset.reviewsSectionInitialized === 'true') return;
    widget.dataset.reviewsSectionInitialized = 'true';

    initSummaryToggle(widget);
    initLightbox(widget);
    initCarousel(widget);
  }

  function initReviewsWidgets(root) {
    root.querySelectorAll('[data-reviews-widget]').forEach(initReviewsWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReviewsWidgets(document);
    });
  } else {
    initReviewsWidgets(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initReviewsWidgets(event.target);
    });
  }
})();
